var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkillsEcoLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4692 16.8994H16.3691V32.9995H32.4692V16.8994Z",
    fill: "url(#paint0_linear_5169_30568)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4692 0.798828H16.3691V16.8989H32.4692V0.798828Z",
    fill: "url(#paint1_linear_5169_30568)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3716 0.798828H0.271484V16.8989H16.3716V0.798828Z",
    fill: "url(#paint2_linear_5169_30568)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5169_30568",
    x1: 16.4056,
    y1: 24.9374,
    x2: 32.5093,
    y2: 24.9374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A893C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEC4DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5169_30568",
    x1: 24.4133,
    y1: 17.1069,
    x2: 24.4133,
    y2: 1.68807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A893C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEC4DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5169_30568",
    x1: 16.1758,
    y1: 8.83789,
    x2: 1.27834,
    y2: 8.83789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A893C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEC4DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsEcoLogo);
export default __webpack_public_path__ + "static/media/skills-eco-logo.0fec0211aaec6f0bc5c8115476d721ca.svg";
export { ForwardRef as ReactComponent };